import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.map = new google.maps.Map(document.getElementById("map"), {
            zoom: 4,
        })
    }
}
